import { render, staticRenderFns } from "./homeworkSubmitted.vue?vue&type=template&id=6ff255bf&scoped=true&"
import script from "./homeworkSubmitted.vue?vue&type=script&lang=js&"
export * from "./homeworkSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./homeworkSubmitted.vue?vue&type=style&index=0&id=6ff255bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff255bf",
  null
  
)

export default component.exports